<template>
	<div class="thumbnail">
		<img :src="finish.thumbnail" @click="select" :alt="finish.title" :title="finish.title" :data-title="finish.title" :data-price-no-vat="finish.price" :data-price-plus-vat="finish.pricePlusVat" :data-finish="finish.renderReference" :data-render="finish.renderReference" data-colour="" class="finish" :class="{'active': isSelected}">
	</div>
</template>

<script>
	export default {
			props: ['finish', 'finishSelectedProp'],
			data() {
					return {};
			},
			methods: {
				select: function() {
					this.$emit('finishSelected', this.finish);
				}
			},
			computed: {
				isSelected: function() {
					return this.finishSelectedProp == this.finish;
				}
			},
	};
</script>

<style scoped>
	.thumbnail {
		width: 35px;
		height: 35px;
		cursor: pointer;
		overflow: hidden;
		border: 1px solid #999;
		border-radius: 50%;
	}

	.finish {
		width: 35px;
		height: 35px;
		transform: scale(1);
		transition: transform 150ms ease;
		border-radius: 50%;
	}

	.finish.active {
		transform: scale(0.7);
		transform-origin: 15px 14px;
		transition: border 150ms ease, transform 150ms ease;
	}
</style>